export default {
      id: "user-usage",
      viewBox: "0 0 12 18",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#user",
      toString: function () {
        return this.url;
      }
    }